module.exports = __webpack_public_path__ + "static/media/pic3.2de5a00b.png";